import { render, staticRenderFns } from "./ConventionCompactInfoTableOfContents.vue?vue&type=template&id=53977f3a"
import script from "./ConventionCompactInfoTableOfContents.vue?vue&type=script&lang=js"
export * from "./ConventionCompactInfoTableOfContents.vue?vue&type=script&lang=js"
import style0 from "./ConventionCompactInfoTableOfContents.vue?vue&type=style&index=0&id=53977f3a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports